import { DatePipe } from "@angular/common";
import { Component, OnInit, ViewChild } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { IRelicenseLab } from "app/models/core/admin/registrationLicense";
import { AdminService } from "app/services/admin/admin.service";
import { SharedService } from "app/services/core/shared.service";

@Component({
  selector: 'app-reLicenseLabs',
  templateUrl: './reLicenseLabs.component.html'
})

export class ReLicenseLabsComponent implements OnInit {

  editMode = '';
  currentDate = '';
  licenseDate = '';
  type = '';

  list: IRelicenseLab[] = [];

  displayedColumns: string[] = ['stateNumber', 'labName'];

  dataSource = new MatTableDataSource<IRelicenseLab>(this.list);

  listFilter = '';

  formGroup = new UntypedFormGroup({
    RelicenseDate: new UntypedFormControl(new Date(), [Validators.required]),
    LicenseType: new UntypedFormControl('', [Validators.required])
  });

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(public adminService: AdminService,
    public sharedService: SharedService,
    private datePipe: DatePipe) { };

  ngOnInit(): void {
    this.editMode = 'process'
  }

  relicense(){
    if (this.formGroup.valid){
      let form = this.formGroup.value;
      this.currentDate = this.datePipe.transform(new Date(), 'MM/dd/yyyy');
      this.licenseDate = this.datePipe.transform(form.RelicenseDate, 'MM/dd/yyyy');
      this.type = form.LicenseType;
      let licDate = this.datePipe.transform(form.RelicenseDate, 'yyyy-MM-dd');
      this.adminService.relicenseLabs(licDate, this.type).subscribe(
        res => {
          this.list = res;
          this.editMode = 'list';
          this.dataSource.data = this.list;
          this.timeout();
        },
        error => console.log('error', error),
        () => {
        }
      );
    };
  }

  timeout() {
    setTimeout(() => {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }, 100);
  }

  tabVisible(type: string): boolean {
    // TODO
    return true;
  }

  filterTable(evnt: Event) {
    this.listFilter = (evnt.target as HTMLInputElement).value;
    this.dataSource.filter = this.listFilter.trim().toLowerCase();
    sessionStorage.setItem('licenseCashFilter', this.listFilter);
  }

  clearFilter() {
    this.listFilter = "";
    this.dataSource.filter = this.listFilter;
    sessionStorage.setItem('licenseCashFilter', this.listFilter)
  }

  getPageSizeOptions(): number[] {
    if (this.dataSource.data.length > 20) {
      return [10, 20, this.dataSource.data.length];
    } else {
      return [10, 20];
    }
  }

}
